import React, { useState, useEffect } from "react"
import MovingSlider from "../MovingSlider/MovingSlider"

import "./DynamicExample.css"

function DynamicExample() {
  const [numCols, setNumCols] = useState(30)
  const [maxHeight, setMaxHeight] = useState(100)
  const [minHeight, setMinHeight] = useState(30)
    const [speed, setSpeed] = useState(3)
    const [images, setImages] = useState([
        "https://picsum.photos/id/424/800/500",
        "https://picsum.photos/id/223/800/500",
        "https://picsum.photos/id/111/800/500",
      ])

  useEffect(() => {
    if (maxHeight < minHeight) {
      setMinHeight(maxHeight)
    }
  }, [maxHeight, minHeight])

    const handleImages = (val) => {
        setImages(val.split(","))
    }
    
  return (
    <div>
      <div className="controls">
        <input
          name="numCols"
          type="range"
          min={1}
          max={40}
          value={numCols}
          onInput={e => setNumCols(eval(e.target.value))}
        />
        <label for="numCols">
          <span>Number of columns: {numCols}</span>
        </label>
        <input
          name="maxHeight"
          type="range"
          min={10}
          max={100}
          value={maxHeight}
          onInput={e => setMaxHeight(eval(e.target.value))}
        />
        <label for="maxHeight">
          <span>maxHeight: {maxHeight}%</span>
        </label>
        <input
          name="minHeight"
          type="range"
          min={10}
          max={100}
          value={minHeight}
          onInput={e => setMinHeight(eval(e.target.value))}
        />
        <label for="minHeight">
          <span>minHeight: {minHeight}%</span>
        </label>
        <input
          name="speed"
          type="range"
          min={1}
          max={20}
          value={speed}
          onInput={e => setSpeed(eval(e.target.value))}
        />
        <label for="speed">
          <span>speed: {speed}s</span>
        </label>
              <input
                  style={{height:`30px`}}
          name="images"
          type="text"
          value={images}
          onInput={e => handleImages(e.target.value)}
        />
 <label for="iamges">
          <span>images: insert the URLs separated by commas</span>
        </label>
      </div>
      <div style={{ height: "300px" }}>
        <MovingSlider
          numColumns={numCols}
          maxHeight={maxHeight}
                  minHeight={minHeight}
                  speed={speed}
          images={images}
        />
      </div>
      <h4>Output:</h4>
      <pre>
        {`
<MovingSlider
    numColumns={${numCols}}
    maxHeight={${maxHeight}}
    minHeight={${minHeight}}
    speed={${speed}}
    images={[${images.map(el => (`"${el}"`))}]}
/>
              `}
      </pre>
    </div>
  )
}

export default DynamicExample
